module.exports = __webpack_public_path__ + "static/og-image-8213365e4060a99f9daa7e2ff002efac.png";